"use client";

import { CheckSquare, Globe, Home, Navigation } from "lucide-react";
import Link from "next/link";
import * as React from "react";

import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarProvider,
} from "@/components/ui/sidebar";
import routes from "@/lib/routes";

const items = [
  {
    title: "Home",
    url: routes.home,
    icon: Home,
  },
  {
    title: "Review URLs",
    url: routes.review,
    icon: CheckSquare,
  },
  {
    title: "Requests",
    url: routes.example_request,
    icon: Navigation,
  },
  {
    title: "Locale",
    url: routes.example_locale,
    icon: Globe,
  },
];

export function AppSidebar() {
  return (
    <SidebarProvider
      style={
        {
          "--sidebar-width": "9rem",
        } as React.CSSProperties
      }
    >
      <Sidebar>
        <SidebarContent>
          <SidebarGroup>
            <SidebarGroupContent>
              <SidebarMenu>
                {items.map((item) => (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton asChild>
                      <Link href={item.url}>
                        <item.icon />
                        <span>{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        </SidebarContent>
      </Sidebar>
    </SidebarProvider>
  );
}
